import ProfileUpdateModal from "./ProfileUpdateModal";
export default ProfileUpdateModal;
